import React from 'react';
import TrackerIcon from './TrackerIcon';
import { PerspAnnotation } from './readThrough';

const PTAGS = ['Commercial', 'Efficacy bar', 'Trial timeline', 'Enrollment and sites', 'Regulatory', 'OS endpoint', 'Class biology', 'Patient population'];

/** perspLi(l) — tracker.js:643-646: tag the leading "Category: " prefix of a reasoning line as a chip. */
const PerspLine: React.FC<{ line: string }> = ({ line }) => {
  const m = line.match(/^([A-Za-z ]+): (.*)$/);
  if (m && PTAGS.includes(m[1])) {
    return <li><span className={`lt c t-${m[1].split(' ')[0].toLowerCase()}`}>{m[1]}</span>{m[2]}</li>;
  }
  return <li>{line}</li>;
};

interface Props {
  annotation: PerspAnnotation;
  company: string;
}

/** The inline "viewing as <company>" card shown on every catalyst row (tracker.js:649-659's perspHTML). */
const PerspectiveAnnotation: React.FC<Props> = ({ annotation: p, company }) => (
  <div className={`persp ${p.kind}`}>
    <div className="pt"><TrackerIcon name="eye" /><b>{p.title}</b><span>· as {company}</span></div>
    {p.lines.length > 0 && (
      <ul className="plines">
        {p.lines.map((l, i) => <PerspLine key={i} line={l} />)}
      </ul>
    )}
    {p.scen && (
      <div className="pscen">
        {p.scen.map((s) => (
          <div key={s.oc} className={`ps ${s.oc}`}>
            <div className="psh">If {s.oc}{s.p != null ? <span> · {s.p}% likely</span> : null}</div>
            <ul>{s.lines.map((l, i) => <PerspLine key={i} line={l} />)}</ul>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default PerspectiveAnnotation;
